export const environment = {
    production: true,
    api_url: 'https://csservice.true360.com/api',
};
